export const withBasicProviders =
  (...providers) =>
  (WrappedComponent) =>
  (props) =>
    providers.reduceRight((acc, Provider) => {
      return <Provider>{acc}</Provider>;
    }, <WrappedComponent {...props} />);
